import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import PopClassRequest from './_PopClassRequest';
import PopAssignment from './_PopAssignment';
import PopMonthlySchedule from './_PopMonthlySchedule';
import PopReservationRoom from './_PopReservationRoom';
function ClassRegisterDetail() {
  const [modalClassRequest, setModalClassRequest] = useState(false); //배정 요청서
  const [modalAssignmentOpen, setModalAssignmentOpen] = useState(false); //배정보고서
  const [modalMonthlySchedule, setModalMonthlySchedule] = useState(false); //교사월간스케줄
  const [modalReservationRoom, setModalReservationRoom] = useState(false); //강의실 예약 스케줄
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  return (
    <main className="com_container p_class_register_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_3">
            수업등록 요청
            <span className="bar" />
            <span className="point_txt">상세보기</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_price_line">수업료 단가표</button>
            <button className="com_btn orange s btn_plus">수업 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box box-1">
            <div className="com_detail_top">
              <button className="state">배정 요청</button>
              <div className="info">
                <p className="tit">홍길동104</p>
                <span className="dot"></span>
                <p className="date">2023.05.20 11:30</p>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <p className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </p>
                  <p className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </p>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-2023-3030</span>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <span className="cont">
                    부)010-2023-3030 <span className="dot" />
                    모)010-3030-3333
                  </span>
                </div>
                <div className="info">
                  <span className="tit">영업정보</span>
                  <p className="cont">
                    회원소개 ㅣ <span className="btn_link">김홍보320</span>
                  </p>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <p className="cont">
                    <span className="btn_link">김담임320</span>
                  </p>
                </div>
                <div className="info">
                  <span className="tit">첫 수업 가능일</span>
                  <span className="cont com_blue_txt">2023.05.05 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1234 모여라 빌딩 203호</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  {/* 20250218 퍼블 수정 */}
                  <span className="tit com_blue_txt">총 수업료</span>
                  <span className="cont com_blue_txt bold">3,123,333</span>
                </div>
              </div>
              <div className="board_item">
                <div className="board_subject name has_btn">
                  수업1 {'<'}과학 / 과탐 / 과탐영역 / 대면{'>'}
                  <button type="button" className="com_btn xxs orange">
                    교사 지목
                  </button>
                </div>
                <div className="info">
                  <span className="tit">수업 상세</span>
                  <span className="cont com_blue_txt">사회문화,경제,밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">타임</span>
                  <span className="cont com_blue_txt">2T</span>
                </div>
                <div className="info">
                  <span className="tit">수업 시간</span>
                  <span className="cont com_blue_txt">30분</span>
                </div>
                <div className="info">
                  <span className="tit">수업 가능 교사</span>
                  <span className="cont com_blue_txt">고3이상</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">교사 지목 </span>
                  <span className="cont com_blue_txt">김교사103</span>
                </div>
                <div className="info">
                  <span className="tit">완성수업</span>
                  <span className="cont">Y ㅣ 16회</span>
                </div>
                <div className="info">
                  <span className="tit">수업 가능일</span>
                  <div className="cont">
                    - 목, 토 19:30 ~ 20:00
                    <br />- 금, 일 19:30 ~ 22:30
                    <br />- 수, 목 19:30 ~ 22:30
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">1회 수업료</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">DC금액 / 사유</span>
                  <span className="cont">-50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">동시수업</span>
                  <span className="cont">김학생103, 최학생450, 강학생654</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont com_blue_txt">2,495,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">메모</span>
                  <span className="cont">부모님이 여자교사, 홍길동 교사를 원하세요.</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">입금과목</span>
                  <span className="cont">과학 / 과탐영역 ㅣ 대면</span>
                </div>
                <div className="info">
                  <span className="tit">입금자ㅣ입금일 </span>
                  <span className="cont">2023, 02, 12 ㅣ 홍길동</span>
                </div>
                <div className="info">
                  <span className="tit">입금방법</span>
                  <span className="cont">카드 ㅣ 현대카드 ㅣ 11234-65546-3213213</span>
                </div>
                <div className="info">
                  <span className="tit">입금액</span>
                  <span className="cont com_blue_txt">12회 ㅣ 350,000원</span>
                </div>
                <div className="info">
                  <span className="tit">확인자</span>
                  <div className="cont">김확인103 ㅣ 2023, 08, 15 ㅣ18:30</div>
                </div>
                <div className="com_btn lightBlue xxs full">입금 완료</div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">입금과목</span>
                  <span className="cont">과학 / 과탐영역 ㅣ 대면</span>
                </div>
                <div className="info">
                  <span className="tit">입금자ㅣ입금일 </span>
                  <span className="cont">2023, 02, 12 ㅣ 홍길동</span>
                </div>
                <div className="info">
                  <span className="tit">입금방법</span>
                  <span className="cont">카드 ㅣ 현대카드 ㅣ 11234-65546-3213213</span>
                </div>
                <div className="info">
                  <span className="tit">입금액</span>
                  <span className="cont com_blue_txt">12회 ㅣ 350,000원</span>
                </div>
                <div className="info">
                  <span className="tit">미금액</span>
                  <span className="cont com_red_txt">4회 ㅣ 350,000원</span>
                </div>
                <div className="info">
                  <span className="tit">확인자</span>
                  <div className="cont">김확인103 ㅣ 2023, 08, 15 ㅣ18:30</div>
                </div>
                <div className="com_btn lightRed xxs full">입금 하기</div>
              </div>
              <div className="board_item">
                <div className="name">
                  김배정103
                  <span className="date">2022, 08, 26 10 : 20</span>
                  <p className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </p>
                </div>
                <div className="info">
                  <div className="memo_cont">
                    <p className="memo_cont__tit">
                      * 수업1 {'<'}과학 / 과탐영역 / 대면{'>'}
                    </p>
                    <p className="memo_cont__cont">
                      - 홍교사123ㅣ45ㅣ9 ㅣ고3ㅣ송파구ㅣ A ㅣ<br />
                      - 첫수업일 : 2024, 05, 12 ㅣ 12 : 30
                      <br />- 수업시간 : 목, 토 ㅣ 12 : 30
                    </p>
                    {/* 20250218 퍼블 추가&수정 */}
                    <p className="memo_cont__tit">
                      * 수업2 {'<'}수시 / 면접 / 대면{'>'}
                    </p>
                    <p className="memo_cont__cont">
                      - 홍교사123ㅣ45ㅣ9 ㅣ고3ㅣ송파구ㅣ A ㅣ<br />
                      - 첫수업일 : 2024, 05, 12 ㅣ 12 : 30
                      <br />- 수업시간 : 목, 토 ㅣ 12 : 30
                    </p>
                  </div>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">승인 불가</span>
                    <button className="name">김승인103</button>
                    <span className="date dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit" />
                    <button className="btn_delete" />
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">이 교사보다 다른 교사를 하는게 좋겠습니다.</div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="com_input_wrap">
                <select className="select">
                  <option value="승인 불가">승인 불가</option>
                </select>
              </div>
              <textarea className="textarea s" placeholder="내용 입력하기"></textarea>
            </div>
            <div className="com_btn_wrap center">
              <button className="com_btn orange xs">확인</button>
            </div>
          </section>
					{/* 20250218 퍼블 추가&수정 */}
          <div className="box_column">
            <div className="class_wrap">
              <section className="box scroll">
                <article className="com_notice_box">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01" >
                      <strong>과학 / 과탐영역 / 대면</strong>
                    </label>
                  </div>
                  <ul className="com_input_sec">
                    <li className="input_row type_col">
                      <div className="tit_field">
                        <span className="com_point_txt">*</span> 첫 수업일
                      </div>
                      <div className="input_field">
                        <div className="date_wrap">
                          <input type="date" className="com_datepicker full xs" placeholder="2022. 01. 01" />
                        </div>
                      </div>
                    </li>
                    <li className="input_row type_col">
                      <div className="tit_field">
                        <span className="com_point_txt">*</span> 수업시간
                      </div>
                      <div className="input_field com_flex_row gap_s">
                        <div className="com_check_date">
                          <input type="checkbox" className="chk_date" id="mon1" />
                          <label htmlFor="mon1">월</label>
                          <input type="checkbox" className="chk_date" id="tue1" />
                          <label htmlFor="tue1">화</label>
                          <input type="checkbox" className="chk_date" id="wed1" />
                          <label htmlFor="wed1">수</label>
                          <input type="checkbox" className="chk_date" id="thu1" />
                          <label htmlFor="thu1">목</label>
                          <input type="checkbox" className="chk_date" id="fri1" />
                          <label htmlFor="fri1">금</label>
                          <input type="checkbox" className="chk_date" id="sat1" />
                          <label htmlFor="sat1">토</label>
                          <input type="checkbox" className="chk_date" id="sun1" />
                          <label htmlFor="sun1">일</label>
                        </div>
                        <select name="" id="" className="select xs">
                          <option value="08시">08시</option>
                        </select>
                        <select name="" id="" className="select xs">
                          <option value="35분">35분</option>
                        </select>
                        <button className="btn_add_dark_gray" title="추가"></button>
                      </div>
                    </li>
                  </ul>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <button className="btn_del_file"></button>
                      <strong className="tit">홍길동</strong>
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button onClick={() => setModalMonthlySchedule(true)} title="교사월간스케줄열기" className="btn_calendar_dark"></button>
                    </div>
                  </div>
                  <div className="desc">
                    수료 ㅣ 원거리 ㅣ 1급 ㅣ 경기도 ㅣ 서울시 ㅣ 강남구 <br />
                    23,000원 + 거리시수 + 3000원
                  </div>
                  <div className="com_btn_wrap">
                    <button className="com_btn xxs lightGray extend" onClick={() => setModalAssignmentOpen(true)}>
                      배정 보고서 작성
                    </button>
                    <button className="com_btn xxs lightGray extend">수업진행 요청서 발송</button>
                  </div>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <button className="btn_del_file"></button>
                      <strong className="tit">홍길동</strong>
                    </div>

                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button onClick={() => setModalMonthlySchedule(true)} title="교사월간스케줄열기" className="btn_calendar_dark"></button>
                    </div>
                  </div>
                  <div className="desc">
                    수료 ㅣ 원거리 ㅣ 1급 ㅣ 경기도 ㅣ 서울시 ㅣ 강남구 <br />
                    23,000원 + 거리시수 + 3000원
                  </div>
                  <div className="com_btn_wrap">
                    <button className="com_btn xxs lightGray extend" onClick={() => setModalAssignmentOpen(true)}>
                      배정 보고서 작성
                    </button>
                    <button className="com_btn xxs lightGray extend">수업진행 요청서 발송</button>
                  </div>
                </article>
              </section>
              <section className="box scroll">
                <article className="com_notice_box">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02" >
                      <strong>수시 / 면접 / 대면</strong>
                    </label>
                  </div>
                  <button className="com_btn xxs orange full" onClick={() => setModalReservationRoom(true)} >강의실 예약 스케줄</button>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <strong className="tit">1회 자소서 : 12월 13일 ㅣ 12시 30분 </strong>
                    </div>
                  </div>
                  <div className="com_flex_row between">
                    <div className="desc">
                      <span className="com_point_txt">*</span> M교사 : 홍길동103 <br />
                      &nbsp; &nbsp; 58,000원 ㅣ 미수료 ㅣ 원거리 ㅣ 1급
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button className="com_btn xxs lightGray">수업진행 요청서 발송</button>
                    </div>
                  </div>
                  <div className="com_flex_row between">
                    <div className="desc">
                      <span className="com_point_txt">*</span> C교사 : 홍길동103 <br />
                      &nbsp; &nbsp; 58,000원 ㅣ 미수료 ㅣ 원거리 ㅣ 1급
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button className="com_btn xxs lightGray">수업진행 요청서 발송</button>
                    </div>
                  </div>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <strong className="tit">1회 자소서 : 12월 13일 ㅣ 12시 30분 </strong>
                    </div>
                  </div>
                  <div className="com_flex_row between">
                    <div className="desc">
                      <span className="com_point_txt">*</span> M교사 : 홍길동103 <br />
                      &nbsp; &nbsp; 58,000원 ㅣ 미수료 ㅣ 원거리 ㅣ 1급
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button className="com_btn xxs lightGray">수업진행 요청서 발송</button>
                    </div>
                  </div>
                  <div className="com_flex_row between">
                    <div className="desc">
                      <span className="com_point_txt">*</span> C교사 : 홍길동103 <br />
                      &nbsp; &nbsp; 58,000원 ㅣ 미수료 ㅣ 원거리 ㅣ 1급
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button className="com_btn xxs lightGray">수업진행 요청서 발송</button>
                    </div>
                  </div>
                </article>
              </section>
              <section className="box scroll">
                <article className="com_notice_box">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01" >
                      <strong>수시 / 자소서 / 화상
											</strong>
                    </label>
                  </div>
                  <ul className="com_input_sec">
                    <li className="input_row type_col">
                      <div className="tit_field">
                        <span className="com_point_txt">*</span> 첫 수업일
                      </div>
                      <div className="input_field">
                        <div className="date_wrap">
                          <input type="date" className="com_datepicker full xs" placeholder="2022. 01. 01" />
                        </div>
                      </div>
                    </li>
                    <li className="input_row type_col">
                      <div className="tit_field">
                        <span className="com_point_txt">*</span> 수업시간
                      </div>
                      <div className="input_field com_flex_row gap_s">
                        <div className="com_check_date">
                          <input type="checkbox" className="chk_date" id="mon1" />
                          <label htmlFor="mon1">월</label>
                          <input type="checkbox" className="chk_date" id="tue1" />
                          <label htmlFor="tue1">화</label>
                          <input type="checkbox" className="chk_date" id="wed1" />
                          <label htmlFor="wed1">수</label>
                          <input type="checkbox" className="chk_date" id="thu1" />
                          <label htmlFor="thu1">목</label>
                          <input type="checkbox" className="chk_date" id="fri1" />
                          <label htmlFor="fri1">금</label>
                          <input type="checkbox" className="chk_date" id="sat1" />
                          <label htmlFor="sat1">토</label>
                          <input type="checkbox" className="chk_date" id="sun1" />
                          <label htmlFor="sun1">일</label>
                        </div>
                        <select name="" id="" className="select xs">
                          <option value="08시">08시</option>
                        </select>
                        <select name="" id="" className="select xs">
                          <option value="35분">35분</option>
                        </select>
                        {/*<button className="btn_add_dark_gray" title="추가"></button>*/}
                      </div>
                    </li>
                  </ul>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <button className="btn_del_file"></button>
                      <strong className="tit">홍길동</strong>
                    </div>
                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button onClick={() => setModalMonthlySchedule(true)} title="교사월간스케줄열기" className="btn_calendar_dark"></button>
                    </div>
                  </div>
                  <div className="desc">
                    수료 ㅣ 원거리 ㅣ 1급 ㅣ 경기도 ㅣ 서울시 ㅣ 강남구 <br />
                    23,000원 + 거리시수 + 3000원
                  </div>
                  <div className="com_btn_wrap">
                    <button className="com_btn xxs lightGray extend" onClick={() => setModalAssignmentOpen(true)}>
                      배정 보고서 작성
                    </button>
                    <button className="com_btn xxs lightGray extend">수업진행 요청서 발송</button>
                  </div>
                </article>
                <article className="com_notice_box">
                  <div className="com_flex_row between">
                    <div className="tit com_flex_row">
                      <button className="btn_del_file"></button>
                      <strong className="tit">홍길동</strong>
                    </div>

                    <div className="com_flex_row">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">지목</label>
                      <button onClick={() => setModalMonthlySchedule(true)} title="교사월간스케줄열기" className="btn_calendar_dark"></button>
                    </div>
                  </div>
                  <div className="desc">
                    수료 ㅣ 원거리 ㅣ 1급 ㅣ 경기도 ㅣ 서울시 ㅣ 강남구 <br />
                    23,000원 + 거리시수 + 3000원
                  </div>
                  <div className="com_btn_wrap">
                    <button className="com_btn xxs lightGray extend" onClick={() => setModalAssignmentOpen(true)}>
                      배정 보고서 작성
                    </button>
                    <button className="com_btn xxs lightGray extend">수업진행 요청서 발송</button>
                  </div>
                </article>
              </section>
            </div>
            <div className="com_btn_wrap bottom center">
							 <span className="com_red_txt left">* 배정 보고서를 작성해 주세요.</span>
							 <button className="com_btn xxs orange">교사배정 승인요청</button>
            </div>
            <section className="box full">
              <div className="com_board_list__top">
              <div className="detail_tit dot">교사 선택</div>
                <div className="com_board_search end">
                <div className="board_select">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">대면</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">화상</label>
                  </div>
                  <select className="select">
                    <option value="지역선택">지역선택</option>
                  </select>
                </div>
                <span className="com_check_box">
                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                  <label htmlFor="chk01">집중관리 교사</label>
                </span>
                <span className="com_check_box">
                  <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                  <label htmlFor="chk02">미수료 교사</label>
                </span>
                  <article className="search">
                    <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input xs type_search" />
                    <button className="com_btn gray ws xs icon_search"></button>
                  </article>
                </div>
              </div>
              <div className="region_box">
                <div className="check">
                  <input type="checkbox" name="chk_area" id="chk_area_01" className="com_chk btn orange" />
                  <label htmlFor="chk_area_01">전체</label>
                  <input type="checkbox" name="chk_area" id="chk_area_02" className="com_chk btn orange" />
                  <label htmlFor="chk_area_02">강남구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_03" className="com_chk btn orange" />
                  <label htmlFor="chk_area_03">강동구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_04" className="com_chk btn orange" />
                  <label htmlFor="chk_area_04">강북구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_05" className="com_chk btn orange" />
                  <label htmlFor="chk_area_05">강서구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_06" className="com_chk btn orange" />
                  <label htmlFor="chk_area_06">관악구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_07" className="com_chk btn orange" />
                  <label htmlFor="chk_area_07">광진구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_08" className="com_chk btn orange" />
                  <label htmlFor="chk_area_08">구로구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_09" className="com_chk btn orange" />
                  <label htmlFor="chk_area_09">금천구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_10" className="com_chk btn orange" />
                  <label htmlFor="chk_area_10">강남구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_11" className="com_chk btn orange" />
                  <label htmlFor="chk_area_11">강동구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_12" className="com_chk btn orange" />
                  <label htmlFor="chk_area_12">강북구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_13" className="com_chk btn orange" />
                  <label htmlFor="chk_area_13">강서구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_14" className="com_chk btn orange" />
                  <label htmlFor="chk_area_14">관악구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_15" className="com_chk btn orange" />
                  <label htmlFor="chk_area_15">광진구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_ 16" className="com_chk btn orange" />
                  <label htmlFor="chk_area_ 16">구로구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_17" className="com_chk btn orange" />
                  <label htmlFor="chk_area_17">금천구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_18" className="com_chk btn orange" />
                  <label htmlFor="chk_area_18">강동구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_19" className="com_chk btn orange" />
                  <label htmlFor="chk_area_19">강북구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_20" className="com_chk btn orange" />
                  <label htmlFor="chk_area_20">강서구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_21" className="com_chk btn orange" />
                  <label htmlFor="chk_area_21">관악구</label>
                  <input type="checkbox" name="chk_area" id="chk_area_22" className="com_chk btn orange" />
                  <label htmlFor="chk_area_22">광진구</label>
                </div>
                <hr className="com_divider" />
                <div className="teacher_wrap">
                  <div className="teacher_list">
                    <div className="teacher_item">
                      <div className="tit">
                        배정 교사(457)
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </div>
                      <div className="list">
                        {[...Array(5)].map((i, idx) => {
                          return (
                            <div key={idx} className={`item ${selectedItem === idx ? 'selected' : ''}`} onClick={() => setSelectedItem(idx)}>
                              <span className="num">{idx + 1}</span>
                              <span className="name">김교사103</span>
                              <span className="region">45ㅣ9ㅣ고3ㅣ송파구45</span>
                            </div>
                          );
                        })}
                        <p className="point icon_arrow_down">원거리 가능 교사</p>
                        {[6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 11, 12, 13, 14, 15].map((i, idx) => {
                          return (
                            <div className="item" key={idx}>
                              <span className="num">{i}</span>
                              <span className="name">박교사103</span>
                              <span className="region">45ㅣ9ㅣ고3ㅣ송파구45</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="teacher_item">
                      <div className="tit">
                        신규 교사 (58)&nbsp;
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </div>

                      <div className="list">
                        {[...Array(5)].map((i, idx) => {
                          return (
                            <div key={idx} className={`item ${selectedItem === idx ? 'selected' : ''}`} onClick={() => setSelectedItem(idx)}>
                              <span className="num">{idx + 1}</span>
                              <span className="name">김교사103</span>
                              <span className="region">45ㅣ9ㅣ고3ㅣ송파구45</span>
                            </div>
                          );
                        })}
                        <p className="point icon_arrow_down">원거리 가능 교사&nbsp;</p>
                        {[6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((i, idx) => {
                          return (
                            <div className="item" key={idx}>
                              <span className="num">{i}</span>
                              <span className="name">박교사103</span>
                              <span className="region">45ㅣ9ㅣ고3ㅣ송파구45</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="teacher_item">
                      <div className="tit">
                        무배정 교사 (208)&nbsp;
                        <button
                          onClick={() => {
                            setIsOrderActive1(!isOrderActive1);
                          }}
                          className={`arrow ${isOrderActive1 ? `active` : ``}`}
                        />
                      </div>
                      <div className="list">
                        {[1, 2, 3, 4, 5].map((i, idx) => {
                          return (
                            <div className="item" key={idx}>
                              <span className="num">{idx + 1}</span>
                              <span className="name">김교사103</span>
                              <span className="region">Cㅣ송파구45</span>
                            </div>
                          );
                        })}
                        <p className="point icon_arrow_down">원거리 가능 교사</p>
                        {[6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((i, idx) => {
                          return (
                            <div className="item" key={idx}>
                              <span className="num">{i}</span>
                              <span className="name">박교사103</span>
                              <span className="region">Cㅣ송파구45</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="com_btn_wrap center bottom">
                    <button className="com_btn black xs icon_arrow_down_orange">선택한 교사 등록</button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
      <PopAssignment open={modalAssignmentOpen} close={() => setModalAssignmentOpen(false)} />
      <PopClassRequest open={modalClassRequest} close={() => setModalClassRequest(false)} />
      <PopMonthlySchedule open={modalMonthlySchedule} close={() => setModalMonthlySchedule(false)} />
      <PopReservationRoom open={modalReservationRoom} close={() => setModalReservationRoom(false)} />
			
    </main>
  );
}

export default ClassRegisterDetail;
